import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import "./viewOffers.css";

import MenuItem from "../../commonComponents/MenuItem/MenuItem";
import { useAuth } from "../../../contexts/AuthContext";
import AllOffers from "../../../data/discounts.json";

import { toast } from "react-toastify";

import Confetti from "../../../images/confetti.png";
import Loader from "../../commonComponents/Loader/Loader";
import { useNavigate } from "react-router-dom";

export default function ViewOffers() {
  const [allOffers, setAllOffers] = useState([]);
  const [discountName, setDiscountName] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const { currentUser, logout } = useAuth();

  const navigate = useNavigate();

  //AllOffers.data.discountItems

  useEffect(() => {
    fetch("https://api.redfoxcafe.ir/v1/client/user-discounts/", {
      method: "GET",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.status === "200") {
          setIsLoading(false);
          if (d.data !== "404") {
            setAllOffers(d.data.discountItems);
            setDiscountName(d.data.discountMode);
          } else return;
        } else if (d.status === "401") {
          toast.info(d.message);
          setIsLoading(false);
          logout();
          navigate("/login", { replace: true });
        } else {
          toast.error(d.message);
        }
      });
  }, []);

  const offerElements = allOffers.map((val) => (
    <MenuItem key={val.ProductTitle} data={val} remainConsistant={true} />
  ));

  return isLoading ? (
    <Loader loading={isLoading} />
  ) : (
    <div className="offers-container">
      {allOffers.length !== 0 ? (
        <>
          <div className="offers-title">
            <span className="offers-title-icon">
              <img src={Confetti} alt="" />
            </span>
            <span className="offers-title-text">تخفیف برای تو</span>
            <span className="offers-mode">{discountName}</span>
          </div>
          <div className="offers custom-scroll">{offerElements}</div>
        </>
      ) : (
        <div className="no-offers-text">{"تخفیفی وجود ندارد (⌣_⌣”)"}</div>
      )}
    </div>
  );
}
